<div class="first-step-container">
  <h2>Share you current position and roles you'd like to explore.</h2>

  <div class="forms">
    <ng-container [formGroup]="form">
      <h3>Current Role</h3>
      <div nz-col nzXs="24" nzMd="24">
        <div
          class="nz-block-input"
					[ngClass]="{
						error:
							form.controls['jobCategoryId'].status === 'INVALID' &&
							form.controls['jobCategoryId'].touched
					}"
          >
          <label for="jobCategoryId">Industry</label>
          <nz-select
            id="jobCategoryId"
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select industry"
            formControlName="jobCategoryId"
            >
            @for (data of jobCategories; track data) {
              <nz-option [nzLabel]="data.option"
                [nzValue]="data.id"
               />
            }
          </nz-select>
        </div>
      </div>
      <div class="row" nz-row nzGutter="16">
        <div nz-col nzXs="24" nzMd="12">
          <div
            class="nz-block-input"
						[ngClass]="{
							error:
								form.controls['specializations'].status === 'INVALID' &&
								form.controls['specializations'].touched
						}"
            >
            <label for="specializations">Current or most recent role</label>
            <nz-select
              id="specializations"
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select current role"
              formControlName="specializations"
              nzMode="multiple"
              [nzMaxTagPlaceholder]="tagPlaceHolder"
              [nzMaxTagCount]="2"
              >
              @for (e of specializations; track e) {
                <nz-option [nzLabel]="e.option"
                  [nzValue]="e.id"
                 />
              }
            </nz-select>
            <ng-template #tagPlaceHolder let-selectedList>and {{ selectedList.length }} more selected</ng-template>
          </div>
        </div>

        <div nz-col nzXs="24" nzMd="12">
          <div
            class="nz-block-input"
						[ngClass]="{
							error:
								form.controls['yearsOfExperience'].status === 'INVALID' &&
								form.controls['yearsOfExperience'].touched
						}"
            >
            <label for="yearsOfExperience">Experience</label>
            <nz-select
              id="yearsOfExperience"
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select years of experience"
              formControlName="yearsOfExperience"
              >
              @for (data of experience; track data) {
                <nz-option [nzLabel]="data.label"
                  [nzValue]="data.value"
                 />
              }
            </nz-select>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="forms">
    <ng-container [formGroup]="form">
      <h3>Roles you're interested in (up to 3)</h3>


        @for (item of jobProfiles; track $index) {
          <div class="jp-item">
            <span class="jp-category">{{ item.categoryName }}</span>
            <div class="jp-role"><span>{{ item.roleName }}</span> <span class="jp-level">{{ item.levelName }}</span><button type="button" (click)="deleteItem(item)" class="btn-delete" aria-label="Delete role"><i class="fa-regular fa-trash-can"></i></button></div>
          </div>
        }
        @if (!isFormEnabled && jobProfiles.length !== 0 && jobProfiles.length < 3) {
          <button type="button" class="add-role-label" (click)="isFormEnabled = !isFormEnabled">+Add role</button>
        }
        @if (isFormEnabled || jobProfiles.length === 0) {
          <app-interested-roles/>
        }
      
    </ng-container>
  </div>


</div>